const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRToggleOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-toggle-off",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.222,20.01c-0,-3.307 2.685,-5.992 5.993,-5.992l14.302,-0c3.308,-0 5.993,2.685 5.993,5.992c-0,3.308 -2.685,5.993 -5.993,5.993l-14.302,-0c-3.308,-0 -5.993,-2.685 -5.993,-5.993Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.222,20.01c-0,-3.307 2.685,-5.992 5.993,-5.992l14.302,-0c3.308,-0 5.993,2.685 5.993,5.992c-0,3.308 -2.685,5.993 -5.993,5.993l-14.302,-0c-3.308,-0 -5.993,-2.685 -5.993,-5.993Zm1.56,0c-0,-2.446 1.986,-4.432 4.433,-4.432c-0,-0 14.302,-0 14.302,-0c2.447,-0 4.433,1.986 4.433,4.432c-0,2.447 -1.986,4.433 -4.433,4.433l-14.302,-0c-2.447,-0 -4.433,-1.986 -4.433,-4.433Z",
    style: {
      fill: "#808080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49,20c0,5.486 4.508,10 9.987,10c5.478,-0 9.986,-4.514 9.986,-10c-0,-5.486 -4.508,-10 -9.986,-10c-5.479,-0 -9.987,4.514 -9.987,10Z",
    style: {
      fill: "#d30000",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRToggleOff);
export default __webpack_public_path__ + "static/media/iconR-toggle-off.215354631a38c059c188278476e0783d.svg";
export { ForwardRef as ReactComponent };